import React, { FC } from 'react';
import { RadioButtons } from '@trip-ux/components';
import { FieldRenderProps } from 'react-final-form';
import { get, isEmpty } from 'lodash';

export const GenericRadioButtons: FC<FieldRenderProps<string> & { ariaLabel?: string }> = ({
  labels,
  input,
  meta,
  validateOnBlur,
  inputOnChange,
  direction = 'row',
  className = '',
  disabled = false,
  id,
  options,
  isRequired,
  newLabel  = '',
}) => {
  return (
    <div className={`mb-auto space-between ${className}`}>
      <RadioButtons
        {...input}
        direction={direction}
        id={id ? id : input.name}
        onBlur={() => input.onBlur()}
        onChange={val => {
          input.onChange(val);
          inputOnChange && inputOnChange(val);
          validateOnBlur && input.onBlur();
        }}
        disabled={disabled}
        isRequired={isRequired}
        className="my-auto text-input-policy"
        error={meta.submitFailed && meta.error}
        options={options}>
          {!isEmpty(newLabel) ? get(labels, newLabel, '') : get(labels, input.name, '')}
      </RadioButtons>
    </div>
  );
};
GenericRadioButtons.displayName = 'GenericRadioButtons';
